<template>
  <transition name="right">
    <div v-if="isMenu" class="menu-wrapper">
      <div class="menu">
				<ul class="link-list">
          <template v-if="isTopLP">
            <li v-for="(menu, idx) in menus" :key="idx"><a @click="closeMenu" :href="menu.href" v-smooth-scroll>{{menu.name}}</a></li>
          </template>
          <div class="button-wrapper">
            <TrialButton :size="'small'"/>
          </div>
          <div class="button-wrapper">
            <LoginButton :size="'small'"/>
          </div>
				</ul>
      </div>
    </div>
  </transition>
</template>

<script>
import menus from '@/mixins/menus'
import TrialButton from '@/components/LP/atoms/TrialButton'
import LoginButton from '@/components/LP/atoms/LoginButton'

export default {
  name: 'Menu',
  components: {
    TrialButton,
    LoginButton
  },
  mixins: [menus],
  props: {
    isMenu: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      isTopLP: this.pathCheck()
    }
  },
  methods: {
    closeMenu () {
      this.$emit('closeMenu', false)
    },
    pathCheck () {
      return location.href.split('/')[3] !== "case_study"
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-wrapper {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  width: 50%;
  height: 100vh;
  background-color: #fefefe;
}
.menu {
  padding: 8px;
  li {
    font-weight: bold;
    padding: 24px;
  }
}
.right-enter-active, .right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.right-enter, .right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
.link-list {
  a {
    color: #333333;
  }
}
.button-wrapper {
  margin-top: 48px;
  margin-left: 16px;
}
@media screen and (max-width: 896px) {
  .menu-wrapper {
    width: 50%;
  }
}
@media screen and (max-width: 480px) {
  .menu-wrapper {
    width: 80%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LP/molecules/Menu.vue